import type { IFile } from '~/types/files';

export const WORKSITE_PHOTO_MAX_BYTES = 1024 * 1024;

export const getPublicFileUrl = (file?: IFile | null): string | null => {
  if (!file?.path) return null;
  const token = localStorage.getItem('token')?.replace(/^JWT\s+/i, '') || '';
  if (!token) return null;
  return `${process.env.REACT_APP_API_URL}/files/public/${file.path}?token=${encodeURIComponent(token)}`;
};
